<div class="d-flex flex-column justify-content-center mt-4">

	<div class="accordion" id="accordionBOperator" *ngFor="let operatorB of listBOperator">
		<div class="accordion-item">
			<h2 class="accordion-header" id="headingOne">
				<button class="accordion-button header-accordion-style" type="button" data-bs-toggle="collapse"
					data-bs-target="#collapseBOperator" aria-expanded="true" aria-controls="collapseBOperator">
					{{getBOperatorId(operatorB)}}
				</button>
			</h2>
			<div id="collapseBOperator" class="accordion-collapse collapse show" aria-labelledby="headingOne"
				data-bs-parent="#accordionBOperator">
				<div class="accordion-body">
					<div class="accordion mt-2" id="accordionCountry" *ngFor="let country of operatorB.listCountry">
						<div class="accordion-item">
							<h2 class="accordion-header" id="headingOne">
								<button class="accordion-button header-accordion-style" type="button"
									data-bs-toggle="collapse" data-bs-target="#collapseCountry" aria-expanded="true"
									aria-controls="collapseCountry">
									{{getCountryName(country)}}
								</button>
							</h2>
							<div id="collapseCountry" class="accordion-collapse collapse show"
								aria-labelledby="headingOne" data-bs-parent="#accordionCountry">
								<div class="accordion-body">
									<div class="d-flex justify-content-center mt-2 addNewAffiliateZeroAffiliate"
										id="addNewAffiliateZeroAffiliate" (click)="addAffiliateToCountry(country)"
										*ngIf="viewAddAffiliateZeroAffiliate(country)">

										<div class="d-flex align-items-center">
											<i class="fa-solid fa-circle-plus fa-2x"></i>
											<span class="small span-icon ">Add Affiliate</span>
										</div>
									</div>

									<div class="accordion" id="accordionAffiliate"
										*ngFor="let affiliate of country.listAffiliate">
										<div class="accordion-item">
											<h2 class="accordion-header" id="headingOne">
												<button class="accordion-button header-accordion-style" type="button"
													data-bs-toggle="collapse" data-bs-target="#collapseAffiliate"
													aria-expanded="true" aria-controls="collapseAffiliate">
													{{getAffiliateName(affiliate)}}
												</button>
											</h2>
											<div id="collapseAffiliate" class="accordion-collapse collapse show"
												aria-labelledby="headingOne" data-bs-parent="#accordionAffiliate">
												<div class="accordion-body">



													<div class="row mt-4">
														<div class="col-md-4">
															<label for="affiliateId">Affiliate Id *</label>
															<input type="text" [(ngModel)]="affiliate.affiliateId"
																[ngClass]="{'input-error': !affiliate || !affiliate.affiliateId}"
																class="form-control" id="affiliateId" name="affiliateId"
																placeholder="AffiliateId">
														</div>
														<div class="col-md-4">
															<label for="affiliateName">Affiliate Name *</label>
															<input type="text" [(ngModel)]="affiliate.affiliateName"
																[ngClass]="{'input-error': !affiliate || !affiliate.affiliateName}"
																class="form-control" id="affiliateName"
																name="affiliateName" placeholder="AffiliateName">
														</div>

														<div class="col-md-4">
															<label for="operator">B Operator *</label>
															<select [(ngModel)]="affiliate.operator" class="form-select"
																[ngClass]="{'input-error': !affiliate || !affiliate.operator}"
																id="operator" name="operator" [disabled]="true">
																<option value="IMSA">IMSA</option>
																<option value="TELIA">TELIA</option>
																<option value="ORANGE">ORANGE</option>
																<option value="TIM">TIM</option>
																<option value="SWISSCOM">SWISSCOM</option>
															</select>
														</div>

													</div>

													<div class="row mt-4">
														<div class="col-md-4">
															<label for="telephoneNumber">Telephone Number</label>
															<input type="text" [(ngModel)]="affiliate.telephoneNumber"
																class="form-control" id="telephoneNumber"
																name="telephoneNumber" placeholder="TelephoneNumber">
														</div>
														<div class="col-md-4">
															<label for="localAgreement">Local Agreements</label>
															<select class="form-select"
																[(ngModel)]="affiliate.localAgreement"
																id="localAgreement" name="localAgreement"
																[disabled]="isDisableLocalAgreement(country)"
																(ngModelChange)="onChangeLocalAgreement($event, operatorB, country, affiliate)">
																<option *ngFor="let item of tendinaAgreements"
																	[ngValue]="item.id">
																	{{ item.id }}
																</option>
															</select>
														</div>
													</div>




													<div class="accordion mt-4" id="accordionDeliveryAddress">
														<div class="accordion-item">
															<h2 class="accordion-header" id="headingOne">
																<button class="accordion-button header-accordion-style"
																	type="button" data-bs-toggle="collapse"
																	data-bs-target="#collapseDeliveryAddress"
																	aria-expanded="true"
																	aria-controls="collapseDeliveryAddress">
																	Delivery Address *
																</button>
															</h2>
															<div id="collapseDeliveryAddress"
																class="accordion-collapse collapse show"
																aria-labelledby="headingOne"
																data-bs-parent="#accordionDeliveryAddress">
																<div class="accordion-body">

																	<div class="row mt-4">
																		<div class="col-md-4">
																			<label for="nameDeliveryAddress">Name
																				*</label>
																			<input type="text"
																				[(ngModel)]="affiliate.deliveryAddress.name"
																				[ngClass]="{'input-error': !affiliate.deliveryAddress || !affiliate.deliveryAddress.name}"
																				class="form-control"
																				id="nameDeliveryAddress"
																				name="nameDeliveryAddress"
																				placeholder="Name">
																		</div>

																		<div class="col-md-4">
																			<label for="street">Street Name *</label>
																			<input type="text"
																				[(ngModel)]="affiliate.deliveryAddress.streetName"
																				[ngClass]="{'input-error': !affiliate.deliveryAddress || !affiliate.deliveryAddress.streetName}"
																				class="form-control" id="street"
																				name="street" placeholder="Street">
																		</div>

																		<div class="col-md-4">
																			<label for="streetNumber">Street Number
																				*</label>
																			<input type="text"
																				[(ngModel)]="affiliate.deliveryAddress.streetNr"
																				[ngClass]="{'input-error': !affiliate.deliveryAddress || !affiliate.deliveryAddress.streetNr}"
																				class="form-control" id="streetNumber"
																				name="streetNumber"
																				placeholder="StreetNumber">
																		</div>


																	</div>

																	<div class="row mt-4">
																		<div class="col-md-4">
																			<label for="city">City *</label>
																			<input type="text"
																				[(ngModel)]="affiliate.deliveryAddress.city"
																				[ngClass]="{'input-error': !affiliate.deliveryAddress || !affiliate.deliveryAddress.city}"
																				class="form-control" id="city"
																				name="city" placeholder="City">
																		</div>

																		<div class="col-md-4">
																			<label for="country">Country *</label>
																			<input type="text"
																				[(ngModel)]="affiliate.deliveryAddress.country"
																				[ngClass]="{'input-error': !affiliate.deliveryAddress || !affiliate.deliveryAddress.country}"
																				class="form-control" id="country"
																				name="country" placeholder="Country">
																		</div>

																		<div class="col-md-4">
																			<label for="postalCode">Postal Code
																				*</label>
																			<input type="text"
																				[(ngModel)]="affiliate.deliveryAddress.postCode"
																				[ngClass]="{'input-error': !affiliate.deliveryAddress || !affiliate.deliveryAddress.postCode}"
																				class="form-control" id="postalCode"
																				name="postalCode"
																				placeholder="PostalCode">
																		</div>


																	</div>

																	<div class="row mt-4">
																		<div class="col-md-4">
																			<label for="givenName">Given Name</label>
																			<input type="text"
																				[(ngModel)]="affiliate.deliveryAddress.givenName"
																				class="form-control" id="givenName" name="givenName"
																				placeholder="GivenName">
																		</div>
				
																		<div class="col-md-4">
																			<label for="title">Title</label>
																			<input type="text"
																				[(ngModel)]="affiliate.deliveryAddress.title"
																				class="form-control" id="title" name="title"
																				placeholder="Title">
																		</div>
																	</div>



																</div>
															</div>
														</div>


													</div>

													<div class="d-flex justify-content-center mt-2"
														(click)="addBillingAccount(affiliate)" style="cursor: pointer;"
														*ngIf="viewAddBillingAccountZeroBillingAccount(affiliate)">
														<div class="d-flex align-items-center ">
															<i class="fa-solid fa-circle-plus fa-2x"></i>
															<span class="small span-icon">Add Billing Account</span>
														</div>
													</div>



													<div class="accordion mt-4" id="accordionBillingAccounts"
														*ngFor="let accounts of affiliate.customerBillingAccount">
														<div class="accordion-item">
															<h2 class="accordion-header" id="headingOne">
																<button class="accordion-button header-accordion-style"
																	type="button" data-bs-toggle="collapse"
																	data-bs-target="#collapseBillingAccount"
																	aria-expanded="true"
																	aria-controls="collapseBillingAccount">
																	Billing Account
																</button>
															</h2>
															<div id="collapseBillingAccount"
																class="accordion-collapse collapse show"
																aria-labelledby="headingOne"
																data-bs-parent="#accordionDeliveryAddress">
																<div class="accordion-body">
																	<div class="row mt-4">

																		<div class="col-md-4">
																			<label for="idBillingAccount">Id</label>
																			<input type="text" [(ngModel)]="accounts.id"
																				class="form-control"
																				id="idBillingAccount"
																				name="idBillingAccount"
																				placeholder="Id">
																		</div>


																	</div>




																	<div class="accordion mt-4"
																		id="accordionDeliveryAddress">
																		<div class="accordion-item">
																			<h2 class="accordion-header"
																				id="headingOne">
																				<button
																					class="accordion-button header-accordion-style"
																					type="button"
																					data-bs-toggle="collapse"
																					data-bs-target="#collapseBillingAddres"
																					aria-expanded="true"
																					aria-controls="collapseBillingAddres">
																					Billing Account Address
																				</button>
																			</h2>
																			<div id="collapseBillingAddres"
																				class="accordion-collapse collapse show"
																				aria-labelledby="headingOne"
																				data-bs-parent="#accordionDeliveryAddress">
																				<div class="accordion-body">

																					<div class="row mt-4">
																						<div class="col-md-4">
																							<label
																								for="nameDeliveryAddress">Name
																								</label>
																							<input type="text"
																								[(ngModel)]="accounts.address.name"
																								class="form-control"
																								id="nameDeliveryAddress"
																								name="nameDeliveryAddress"
																								placeholder="Name">
																						</div>

																						<div class="col-md-4">
																							<label for="street">Street
																								Name</label>
																							<input type="text"
																								[(ngModel)]="accounts.address.streetName"
																								class="form-control"
																								id="street"
																								name="street"
																								placeholder="Street">
																						</div>

																						<div class="col-md-4">
																							<label
																								for="streetNumber">Street
																								Number</label>
																							<input type="text"
																								[(ngModel)]="accounts.address.streetNr"
																								class="form-control"
																								id="streetNumber"
																								name="streetNumber"
																								placeholder="StreetNumber">
																						</div>


																					</div>

																					<div class="row mt-4">
																						<div class="col-md-4">
																							<label for="city">City
																								</label>
																							<input type="text"
																								[(ngModel)]="accounts.address.city"
																								class="form-control"
																								id="city" name="city"
																								placeholder="City">
																						</div>

																						<div class="col-md-4">
																							<label for="country">Country
																								</label>
																							<input type="text"
																								[(ngModel)]="accounts.address.country"
																								class="form-control"
																								id="country"
																								name="country"
																								placeholder="Country">
																						</div>

																						<div class="col-md-4">
																							<label
																								for="postalCode">Postal
																								Code
																								</label>
																							<input type="text"
																								[(ngModel)]="accounts.address.postCode"
																								class="form-control"
																								id="postalCode"
																								name="postalCode"
																								placeholder="PostalCode">
																						</div>


																					</div>



																				</div>
																			</div>
																		</div>


																	</div>





																</div>
															</div>
														</div>
														<div class="d-flex justify-content-between mt-2">

															<div (click)="addBillingAccount(affiliate)"
																*ngIf="viewAddBillingAccount(accounts, affiliate)"
																style="cursor: pointer;">
																<div class="d-flex align-items-center">
																	<i class="fa-solid fa-circle-plus fa-2x"></i>
																	<span class="small span-icon">Add Billing
																		Account</span>
																</div>
															</div>

															<div (click)="removeBillingAccount(affiliate, accounts)"
																style="cursor:pointer;">
																<div class="d-flex align-items-center">
																	<i class="fa-solid fa-x fa-2x"></i>
																	<span class="small span-icon">Remove Billing
																		Account</span>
																</div>
															</div>





														</div>


													</div>






												</div>
											</div>
										</div>
										<div class="d-flex justify-content-between mt-2">

											<div (click)="addAffiliateToCountry(country)"
												*ngIf="viewAddAffiliate(country, affiliate)" style="cursor: pointer;">
												<div class="d-flex align-items-center">
													<i class="fa-solid fa-circle-plus fa-2x"></i>
													<span class="small span-icon ">Add Affiliate</span>
												</div>
											</div>

											<div (click)="removeAffiliate(country, affiliate)"
												
												style="cursor: pointer;">
												<div class="d-flex align-items-center">
													<i class="fa-solid fa-x fa-2x"></i>
													<span class="small span-icon">Remove Affiliate</span>
												</div>
											</div>





										</div>
									</div>






								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>



</div>

<div class="row mt-4">
	<span class="span-error" *ngIf="customerDataAffiliateFormDisabled()">Add at least one affiliate and fill in all
		mandatory fields marked with
		* to save or go to the next step.</span>
</div>
<div class="d-flex justify-content-end mt-4">
	<button class="btn btn-primary btn-lg active back-button btn-sm"
		(click)="backToStepCustomerDataCountry()">Back</button>
	<button class="btn btn-primary btn-lg active btn-sm" style="margin-left:2%;"
		[disabled]="customerDataAffiliateFormNextDisabled()" (click)="goToStepCustomerDepartment()">Next</button>
	<button class="btn btn-primary btn-lg active button-save btn-sm"
		[disabled]="customerDataAffiliateFormDisabled() || disableForm()" (click)="saveCustomer()">Save</button>
	<button class="btn btn-primary btn-lg active button-reset btn-sm" [disabled]="disableForm()"
		(click)="resetForm()">Reset</button>
</div>